import { ResponseModalComponent } from './../../components/response-modal/response-modal.component';
import { ResponseModal2Component } from './../../components/response-modal2/response-modal2.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UsersService } from "../../services/admin/users.service";
import { User } from '../../models/user';
import { NgbModal, ModalDismissReasons, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from './../../services/admin/general.service';
import { FormRegisterComponent } from './form-register/form-register.component';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { FilterUserDialogComponent } from '../../components/filter-user-dialog/filter-user-dialog.component';
import { ToasterModule, ToasterService, Toast } from 'angular5-toaster';
import { StorageService } from '../../services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { passwordValidator } from '../../shared/validators/password.validator';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  providers: [GeneralService]
})
export class UsersComponent implements OnInit {
  @ViewChild('popover') popover: NgbPopover | undefined; // popover de requisitos de contraseña

  private language = localStorage.getItem('LOCAL_STORAGE');
  selected: any;
  rows = [];
  rows_sociedades = [];
  editEnabled: boolean = false;
  closeResult: string;
  centros_costo = [];
  verDetalle = false;
  busy: boolean = false;
  busyListado: boolean = false;
  busyInfo: boolean = false;
  public registrationForm: FormGroup;
  tituloModal = '';
  mensajeModal = '';

  //USER dATA FOR CACHE

  passwordEdt = "";
  emailEdt = "";
  nombre: "";
  rfcEdt: "";
  sociedadEdt: "";
  usernameEdt: "";
  direccionEdt: "";
  telefonoEdt: "";
  nombreUsuario: "";
  complementoObligatorio = false;
  cartaPorte = false;
  btnOptsProveedor = false;

  tituloCambiarEstado;
  estasSeguro;
  elUsuario;
  estadoActivar;
  estadoInactivar;
  tituloEliminarUsuario;
  mensajeEliminarUsuario;

  VerFactsOC = "";
  VerFactsSOC = "";
  VerReportes = "";
  VerComplementos = "";
  VerFacturas = "";
  VerFacturasAnticipos = "";
  VerFactsDC = "";
  VerFactsEC = "";
  VerFactsBatch = "";
  VerComprobantes = "";


  Empleado = "";
  Proveedor = "";
  Administrador = "";

  seleccion;
  mensajeError;

  permisos = [
    { id: 1, enabled: false, description: this.VerFactsOC },
    { id: 2, enabled: false, description: this.VerFactsSOC },
    { id: 3, enabled: false, description: this.VerReportes },
    { id: 4, enabled: false, description: this.VerComplementos },
    { id: 5, enabled: false, description: this.VerFacturas },
    { id: 6, enabled: false, description: this.VerFacturasAnticipos },
    { id: 7, enabled: false, description: this.VerFactsDC },
    { id: 8, enabled: false, description: this.VerFactsEC },
    { id: 9, enabled: false, description: this.VerFactsBatch },
    { id: 10, enabled: false, description: this.VerComprobantes },
    // { id: 10, enabled: false, description: "Aut. Entrada de servicios" },
    // { id: 11, enabled: false, description: "Recepción de mercancias" },
  ];

  roles = [
    { id: 2, nombre: this.Empleado },
    { id: 3, nombre: this.Proveedor },
    { id: 1, nombre: this.Administrador }
  ]
  countries = ['MX', 'US'];
  toastErrorBorrarRegistro;
  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private userService: UsersService,
    private modalService: NgbModal,
    private toasterService: ToasterService,
    private storageService: StorageService,
    private formBuilder: FormBuilder
  ) {
    this.translate.get('texto.toastErrorBorrarRegistro').subscribe(
      text => {
        
        this.toastErrorBorrarRegistro = text;
      });
    this.translate.get('texto.cambiarEstado').subscribe(
      text => {
        
        this.tituloCambiarEstado = text;
      });
    this.translate.get('texto.estasSeguro').subscribe(
      text => {
        
        this.estasSeguro = text;
      });
    this.translate.get('texto.elUsuario').subscribe(
      text => {
        
        this.elUsuario = text;
      });
    this.translate.get('texto.activar').subscribe(
      text => {
        
        this.estadoActivar = text;
      });
    this.translate.get('texto.inactivar').subscribe(
      text => {
        
        this.estadoInactivar = text;
      });
    this.translate.get('texto.eliminarUsuarioTitulo').subscribe(
      text => {
        
        this.tituloEliminarUsuario = text;
      });
    this.translate.get('texto.eliminarUsuarioMensaje').subscribe(
      text => {
        
        this.mensajeEliminarUsuario = text;
      });
    this.translate.get('texto.VerFactsOC').subscribe(
      text => {
        
        this.VerFactsOC = text;
      });
    this.translate.get('texto.VerFactsSOC').subscribe(
      text => {
        
        this.VerFactsSOC = text;
      });
    this.translate.get('texto.VerReportes').subscribe(
      text => {
        
        this.VerReportes = text;
      });
    this.translate.get('texto.VerComplementos').subscribe(
      text => {
        
        this.VerComplementos = text;
      });
    this.translate.get('texto.VerFacturas').subscribe(
      text => {
        
        this.VerFacturas = text;
      });
    this.translate.get('texto.VerFacturasAnticipos').subscribe(
      text => {
        
        this.VerFacturasAnticipos = text;
      });
    this.translate.get('texto.VerFactsDC').subscribe(
      text => {
        
        this.VerFactsDC = text;
      });
    this.translate.get('texto.VerFactsEC').subscribe(
      text => {
        
        this.VerFactsEC = text;
      });
    this.translate.get('texto.CargaDeFacturasMasiva').subscribe(
      text => {
        
        this.VerFactsBatch = text;
      });
    this.translate.get('texto.tipoProveedor').subscribe(
      text => {
        
        this.Proveedor = text;
      });
    this.translate.get('texto.tipoEmpleado').subscribe(
      text => {
        
        this.Empleado = text;
      });
    this.translate.get('texto.tipoAdministrador').subscribe(
      text => {
        
        this.Administrador = text;
      });
    this.translate.get('texto.error').subscribe(
      text => {
        
        this.mensajeError = text;
      });
    this.translate.get('texto.Comprobantes').subscribe(
      text => {
        
        this.VerComprobantes = text;
      });


  }

  ngOnInit() {
    if (this.language) {
      this.language = this.language.replace(/["']/g, "")
    }

    this.noBack();
    this.modulo();
    this.loadUserList();
    this.rows = [];
    this.loadSociedades();
    this.editEnabled = false;
    this.rolesUser();
    this.registrationForm = this.formBuilder.group({
      nombreUsuario: ['', Validators.minLength(1)],
      nombre: ['', Validators.minLength(1)],
      pais: ['', Validators.minLength(1)],
      password: ['', [passwordValidator]],
      //  permiso: ['', Validators.minLength(1)],
      emailEdt: ['', Validators.compose([Validators.required,
      Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$'),
      Validators.minLength(1)])],
      direccion: [''],
      telefono: [''],
      rfc: ['']
    });
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Usuarios').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  rolesUser() {
    if (this.language == "es") {
      this.roles = [
        { id: 2, nombre: 'Empleado' },
        { id: 3, nombre: 'Proveedor' },
        { id: 1, nombre: 'Administrador' }
      ]
    } else {
      this.roles = [
        { id: 2, nombre: 'Employee' },
        { id: 3, nombre: 'Supplier' },
        { id: 1, nombre: 'Administrator' }
      ]
    }
  }

  private loadUserList() {
    this.busy = true;
    this.verDetalle = false;
    this.userService.getUsers().subscribe(
      data => {
        this.pupulateTable(data);
        this.busy = false;
      },
      err => {
        this.busy = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );

  }

  reload() {
    this.busyListado = true;
    this.verDetalle = false;
    this.editEnabled = false;
    this.userService.getUsers().subscribe(
      data => {
        this.pupulateTable(data);
        this.busyListado = false;
      },
      err => {
        this.busyListado = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );

  }



  loadUserPermisions(userId: number) {
    this.userService.getUsersPermissions(userId).subscribe(

      data => {
        // console.log(data);
        // this.us = data.sapCosto;
        this.setPermisos(data.permisos);
      }
      ,
      err => {

        // console.log(err);

      },
    );
  }


  private loadSociedades() {
    this.userService.getSociedades().subscribe(
      data => this.rows_sociedades = data.sapSociedad
      ,
      err => {

        // console.log(err);

      },
    );
  }

  changeRol(e) {
    if (e.target.value == 3) { 
      this.btnOptsProveedor = true;
    } else {
      this.btnOptsProveedor = false;
    }
  }

  private pupulateTable(data) {
    this.rows = data.usuario;
  }

  onSelect(event, user, i) {
    this.editData(false);
    this.selected = user;
    this.seleccion = this.rows[i];
    this.passwordEdt = this.selected.password;
    this.emailEdt = this.selected.email;
    this.direccionEdt = this.selected.direccion;
    this.telefonoEdt = this.selected.telefono;
    this.rfcEdt = this.selected.rfc;
    this.complementoObligatorio = this.selected.complemento_obligatorio;
    this.cartaPorte = this.selected.cartaporte_obligatorio;
    
    if (this.selected.rol.nombre == "proveedor") { 
      this.btnOptsProveedor = true;
    } else {
      this.btnOptsProveedor = false;
    }

    this.loadUserPermisions(this.selected.id);
    this.verDetalle = true;
    this.editEnabled = false;
    if (localStorage.getItem("seleccion") !== null) {
      localStorage.removeItem('seleccion');
    }
  } 

  onActivate(event) {
    // console.log('Activate Event', event);
  }


  updateUser() {

  }

  deleteUser(id) {

    const modalRef = this.modalService.open(ResponseModalComponent, { centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.titulo = this.tituloEliminarUsuario;
    modalRef.componentInstance.mensaje1 = this.mensajeEliminarUsuario;

    modalRef.result.then((result) => {
      // console.log(result);

      if (result === 'aceptar') {
        this.busy = true;
        this.userService.borrarUser(id).subscribe(
          data => {
            if (data.success) {
              this.busy = false;
              this.ngOnInit();
              this.verDetalle = false;
              this.toasterService.pop('success', data.message);
            } else {
              this.busy = false;
              this.toasterService.pop('error', this.toastErrorBorrarRegistro);
            }

          },
          err => {
            this.busy = false;
            this.toasterService.pop('error', this.toastErrorBorrarRegistro);
            if (err.status === 401) {
              this.storageService.openLogout();
            } 
          },
        );

      }
    });

  }

  private editData(status) { 
    if (this.editEnabled) { 
      this.editEnabled = status;
      var st = localStorage.getItem('seleccion');
      var jst = JSON.parse(st);
      // console.log(JSON.parse(st));

      this.nombreUsuario = jst.username;
      this.nombre = jst.nombre;
      this.emailEdt = jst.email;
      this.passwordEdt = jst.password;
      this.selected.pais = jst.pais;
      this.direccionEdt = jst.direccion;
      this.telefonoEdt = jst.telefono;
      this.rfcEdt = jst.rfc;
      this.cartaPorte = jst.cartaporte_obligatorio;
      this.complementoObligatorio = jst.complemento_obligatorio;

      if (jst.rol.id == 3) { 
        this.btnOptsProveedor = true;
      } else {
        this.btnOptsProveedor = false;
      }
      

      localStorage.removeItem('seleccion');

      // se cierra el popover de validación de contraseña
      if (this.popover) this.popover.close();

    } else { 
      this.editEnabled = status;
      localStorage.setItem('seleccion', JSON.stringify(this.selected));
    }

  }

  open(content) {
    const modalRef = this.modalService.open(FormRegisterComponent, { backdrop: 'static', keyboard: false });
    modalRef.result.then((result) => {
      // console.log(result);
      this.ngOnInit();
    }).catch((error) => {
      // console.log(error);
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openFilterDialof() {
    const modalRef = this.modalService.open(FilterUserDialogComponent, { size: 'sm', centered: true, keyboard: false, backdrop: 'static' });
    modalRef.result.then((result) => {
      // console.log(result);
      if (result !== 'close') {
        this.performSearch(result);
      }


    }).catch((error) => {
      // console.log(error);
    });
    modalRef.componentInstance.name = 'World';
    modalRef.componentInstance.option = 'World';
  }


  performSearch(data: any) {

    //perform searh by filter and set the filter for refresh
    let tipo = data.tipo;
    let valor = data.criterio;

    this.userService.filterUsers(tipo, valor).subscribe(
      data => {
        this.pupulateTable(data)
        this.editEnabled = false;
        this.verDetalle = false;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );

  }



  setPermisos(userPermissions: any) {

    this.permisos = [
      { id: 1, enabled: false, description: this.VerFactsOC },
      { id: 2, enabled: false, description: this.VerFactsSOC },
      { id: 3, enabled: false, description: this.VerReportes },
      { id: 4, enabled: false, description: this.VerComplementos },
      { id: 5, enabled: false, description: this.VerFacturas },
      { id: 6, enabled: false, description: this.VerFacturasAnticipos },
      { id: 7, enabled: false, description: this.VerFactsDC },
      { id: 8, enabled: false, description: this.VerFactsEC },
      { id: 9, enabled: false, description: this.VerFactsBatch},
      { id: 10, enabled: false, description: this.VerComprobantes},
      // { id: 10, enabled: false, description: "Aut. Entrada de servicios" },
      // { id: 11, enabled: false, description: "Recepción de mercancias" },
    ];


    for (let p of userPermissions) {
      // console.log(p);
      this.permisos.find(x => x.id === p.permiso_id).enabled = true;
    }



  }


  saveUserInfo() {
    this.busy = true;
    // console.log(this.permisos);
    let permisos = [];
    if (this.permisos.length > 0) {
      for (let i = 0; i < this.permisos.length; i++) {
        if (this.permisos[i].enabled) {
          permisos.push(this.permisos[i])
        }
      }
    }

    var emailLC;
    if (this.emailEdt !== undefined || this.emailEdt !== null || this.emailEdt !== "") {
      if (typeof (this.emailEdt) == 'string') {
        emailLC = this.emailEdt.toLowerCase();
      }
    }

    // console.log(typeof (this.rfcEdt));
    var rfcUC;
    if (this.rfcEdt !== undefined || this.rfcEdt !== null || this.rfcEdt !== "") {
      if (typeof (this.rfcEdt) == 'string') {
        rfcUC = this.rfcEdt.toUpperCase();
      }
    }

    const passwordControl = this.registrationForm.get('password');

    // si la contraseña no cumple con los requisitos, se muestra el popover
    if (passwordControl && passwordControl.errors) {
      if (this.popover) {
        this.popover.open();
      }
      
      this.busy = false;
      return;
    }

    let idUser = this.selected.id
    let userData = this.selected
    userData.permisos = permisos
    userData.password = this.passwordEdt
    userData.email = emailLC
    userData.direccion = this.direccionEdt
    userData.telefono = this.telefonoEdt
    userData.username = this.nombreUsuario
    userData.nombre = this.nombre
    userData.rfc = rfcUC;
    userData.complemento_obligatorio = this.complementoObligatorio
    userData.cartaporte_obligatorio = this.cartaPorte

    // console.log(this.selected, this.complementoObligatorio);
    let validForm = true
    if (validForm) {

      this.userService.updateUser(idUser, userData).subscribe(
        data => {

          localStorage.removeItem('seleccion');
          if (data != null) {
            this.busy = false;
            this.toasterService.pop('success', data.message);
          } else {
            this.toasterService.pop('error', data.message);
          }
          this.ngOnInit();
          //  console.log(resp.headers.get('Cookie'));
        },
        err => {
          this.busy = false;
          if (err.status === 400) {
            const modalRef = this.modalService.open(ResponseModal2Component, { centered: true, keyboard: false, backdrop: 'static' });
            modalRef.componentInstance.titulo = this.mensajeError;
            modalRef.componentInstance.mensaje1 = err.error.message;

            modalRef.result.then((result) => {
              // console.log(result);
              if (result == 'cancelar') {
                this.reload();
                /*  var st = localStorage.getItem('seleccion');
                  var jst = JSON.parse(st);
                  console.log(JSON.parse(st));
  
                  this.nombreUsuario = jst.username;
                  this.nombre = jst.nombre;
                  this.emailEdt = jst.email;
                  this.passwordEdt = jst.password;
                  this.selected.pais = jst.pais;
                  this.direccionEdt = jst.direccion;
                  this.telefonoEdt = jst.telefono;
                  this.rfcEdt = jst.rfc;
  
                  localStorage.removeItem('seleccion');
                */
              }
            });
          }

          if (err.status === 401) {
            this.storageService.openLogout();
          } 
        },
      );
    } else {
      this.busy = false;
    }
  }

  cambiarEstatus(id, estatus) {
    var estado = '';
    if (estatus == true) {
      estatus = false;
      estado = this.estadoInactivar;
    } else {
      estatus = true;
      estado = this.estadoActivar;
    }

    const modalRef = this.modalService.open(ResponseModalComponent, { centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.titulo = this.tituloCambiarEstado;
    modalRef.componentInstance.mensaje1 = this.estasSeguro;
    modalRef.componentInstance.mensaje2 = this.elUsuario;
    modalRef.componentInstance.mensaje3 = estado;

    modalRef.result.then((result) => {
      // console.log(result);
      if (result === 'aceptar') {
        this.userService.estatusUsuario(id, estatus).subscribe(
          data => {
            // console.log(data);
            this.loadUserList();
            this.verDetalle = false;
          }
          ,
          err => {
            // console.log(err);
          },
        );
      }
    });

  }


  getTraslatedText(value) {    

    if (this.language === "en") {
      switch (value) {
        case "administrador":
          return "administrator" 
        case "empleado":
          return "employee"  
        case "proveedor":
          return "supplier"  
        default: 
          break;
      }
    } 
  }

  // validaciones de contraseña segura
  passwordHasError(errorKey: string): boolean {
    const passwordControl = this.registrationForm.get('password');
    if (!passwordControl || !passwordControl.errors) {
      return true; // no hay error
    }

    return !passwordControl.errors[errorKey];
  }

  get hasMinLength(): boolean { return this.passwordHasError('minLength') }
  get hasUppercase(): boolean { return this.passwordHasError('noUppercase') }
  get hasLowercase(): boolean {  return this.passwordHasError('noLowercase') }
  get hasNumber(): boolean {  return this.passwordHasError('noNumber') }
  get hasSpecialChar(): boolean { return this.passwordHasError('noSpecial') }

}



// WEBPACK FOOTER //
// ./src/app/pages/users/users.component.ts